import { histogramModal as histogramDiagram} from '@process-advisor/process-miner/processMiner/processMiner';

export type HistogramProps = {
    param1?: string,
    param2?: string,
};

export const histogram = ({ param1, param2}: HistogramProps) => {
    histogramDiagram();
};


